import AbstractTimezone from './AbstractTimezone';

class TimezoneContentOnly extends AbstractTimezone {
  render() {
    this.content.element && this.$parent?.append(this.content.element);
    this.content.update();
  }
}

export default TimezoneContentOnly;